import api from '../../api/userAPI';
import { setErrorNotification } from '../snackbarNotification';

export const FETCH_BEGIN = 'visitRemindner.list/FETCH_BEGIN';
export const FETCH_SUCCESS = 'visitRemindner.list/FETCH_SUCCESS';
export const FETCH_FAILED = 'visitRemindner.list/FETCH_FAILED';

const fetchBegin = () => ({ type: FETCH_BEGIN });
const fetchSuccess = data => ({ type: FETCH_SUCCESS, payload: data });
const fetchFailed = error => ({ type: FETCH_FAILED, payload: error });
export const fetchVisitReminderList = () => async dispatch => {
  dispatch(fetchBegin());

  try {
    const res = await api(`retrieve-visit-reminder`);

    dispatch(fetchSuccess(res.data.result));
  } catch (error) {
    dispatch(fetchFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_BEGIN:
      return { ...state, data: [], isLoading: true, error: null };
    case FETCH_SUCCESS:
      return { ...state, data: payload, isLoading: false };
    case FETCH_FAILED:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
};

export default reducer;

const initialState = {
  data: [],
  isLoading: false,
  error: null
};
